import React from 'react';
import PropTypes from 'prop-types';
import { stylesPropType, vmPropTypes } from '../../global-prop-types';

const JmeText = (props) => {
  const {
    styles,
    text,
    // TODO: remove after replacing it with text in databases
    // parent,
    elemType = 'p',
    variant
  } = props;
  const TextElm = elemType;

  if (!text) return null;

  return (
    <TextElm
      className={`jme-text-wrapper jme-text-${elemType} ${variant || ''}`}
      style={styles?.wrapper}
    >
      {text}
    </TextElm>
  );
};

JmeText.propTypes = {
  // parent: PropTypes.array,
  styles: stylesPropType,
  elemType: PropTypes.string,
  variant: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

JmeText.defaultProps = {
  variant: '',
  styles: { wrapper: {} },
  elemType: 'p',
  text: 'Example text'
};

JmeText.vmPropTypes = {
  styles: { wrapper: vmPropTypes.styles },
  elemType: vmPropTypes.string,
  variant: vmPropTypes.className,
  text: vmPropTypes.string
};

export default JmeText;
